export default __webpack_public_path__ + "static/media/nh.6711c628.png";